import { LocaleContext } from 'context/locale.context'
import { useContext, useEffect } from 'react'
import useSWR from 'swr'

export const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = event => {
      if (!ref.current || ref.current.contains(event.target)) {
        return
      }
      handler(event)
    }
    document.addEventListener('mousedown', listener)
    return () => {
      document.removeEventListener('mousedown', listener)
    }
  }, [ref, handler])
}

export const useFetchPage = (key, fetcher) => {
  const { data, error } = useSWR(`${key}`, fetcher)
  return {
    data: data?.data?.attributes,
    isLoading: !error && !data,
    isError: error
  }
}

export const useLocale = () => {
  const { locale, setLocale } = useContext(LocaleContext)
  return { locale, setLocale }
}
